module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticClass: "overflow-x-hidden"
  }, [_c('div', {
    staticClass: "imgbackground"
  }), _c('div', {
    staticClass: "timeline pt5"
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 500,
        duration: 200
      }),
      expression: "{offset: 500, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fixed-bottom-right animate-pop z-999",
    staticStyle: {
      "margin": "0 30px 30px 0"
    },
    attrs: {
      "round": "",
      "color": "negative"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-2x white"
  })]), _vm._l((_vm.timelines), function(time) {
    return (_vm.timelines) ? _c('div', [_c('div', {
      staticClass: "titretimeline ttu"
    }, [_c('div', {
      staticClass: "white"
    }, [_vm._v("A timeline of songs and writers")])]), _vm._l((_vm.triTimeline(time.timeline_containers)), function(details, index) {
      return (index > 0) ? _c('div', {
        staticClass: "fulldatecontainer"
      }, [_c('div', {
        staticClass: "datecontainer"
      }, [_c('div', {
        staticClass: "animal"
      }, [_c('img', {
        attrs: {
          "src": details.zodiac
        }
      })]), _c('div', {
        staticClass: "date"
      }, [_c('span', {
        staticClass: "datenumber"
      }, [_vm._v(_vm._s(details.annee))])])]), _c('div', {
        staticClass: "secondarydates white"
      }, [_c('span', {
        staticClass: "pr1"
      }, [_vm._v("Hebraic year")]), _c('span', {
        staticClass: "pl1"
      }, [_vm._v(_vm._s(details.val[0].hebrew_year))])]), _c('div', {
        staticClass: "contenutimeline mb2 mt2 shadow-5"
      }, _vm._l((details.val), function(info, index) {
        return _c('div', [_c('h1', [_vm._v(_vm._s(info.container.titre))]), _c('p', {
          domProps: {
            "innerHTML": _vm._s(info.container.description)
          }
        }), _vm._l((info.container.medias), function(med) {
          return _c('div', {
            staticClass: "pt3"
          }, [(med.mediable_type === 'Image') ? _c('div', [(med.image.thumbnail) ? _c('img', {
            attrs: {
              "src": med.image.thumbnail,
              "width": "90%",
              "height": "90%"
            }
          }) : _vm._e(), _c('p', {
            staticClass: "descriptionimg",
            domProps: {
              "innerHTML": _vm._s(med.image.description)
            }
          })]) : _vm._e(), (med.mediable_type === 'Video') ? _c('div', [_c('video-vimeo', {
            attrs: {
              "med": med
            }
          })], 1) : _vm._e()])
        }), (info.container.tag_visibles.length > 0) ? _c('div', [_c('q-btn', {
          staticClass: "historybtn center",
          on: {
            "click": function($event) {
              _vm.goTo(info.container.tag_visibles[0].name)
            }
          }
        }, [_vm._v("Read more")])], 1) : _vm._e(), (details.val.length > 1 && index % 2 === 0) ? _c('hr', {
          staticClass: "lignestyle"
        }) : _vm._e()], 2)
      }))]) : _vm._e()
    })], 2) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b8ae724","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Story/Timeline.vue
// module id = 1284
// module chunks = 1